import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ChatbotButtonComponent } from './chatbot-button/chatbot-button.component';
import { ChatbotWidgetComponent } from './chatbot-widget/chatbot-widget.component';
import { AgentService } from './services/agent.service';
import { ChatbotStateService } from './services/chatbot-state.service';

@NgModule({
  declarations: [
    ChatbotButtonComponent,
    ChatbotWidgetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
  ],
  providers: [
    AgentService,
    ChatbotStateService
  ],
  exports: [
    ChatbotButtonComponent
  ]
})
export class ChatbotModule { }

